<template>
  <g v-if="isVisible" class="flow__color" :class="{ 'flow__color-dragging': dragging }">
    <polyline :points="points" fill="transparent" />
    <circle
      v-bind="shape.attributes"
      :id="id"
      stroke-width="1"
      fill="transparent"
      :r="radius"
      class="flow__circle"
      :class="{
        'flow__circle-dragging': dragging,
        'flow__circle-disabled': disabled,
      }"
      @mousedown="startDrag"
      @click="setSelectedShape"
      @mousemove="mouseMove"
    >
    </circle>
    <g v-if="cluePointsId === id">
      <clue-points :attributes="shape.attributes" />
    </g>
  </g>
</template>

<script>
import { SelectionType, ShapeType } from "./Constants";
import { SPACE_BETWEEN_VLINES } from "./ElementUtils";
import CluePoints from "./CluePoints.vue";
import { getAndPoints, getOrPoints, getXorPoints, RADIUS } from "./ElementUtils";
import DesignerMixin from "../../../DesignerMixin";
import { HotkeyScopes } from "../../../../../utils/constants";
import hotkeys from "hotkeys-js";
export default {
  components: {
    CluePoints,
  },
  mixins: [DesignerMixin],
  props: ["id"],
  data() {
    return {
      dragging: false,
      pflowLeft: null,
      disabled: false,
    };
  },
  computed: {
    shape() {
      return this.$store.state.customFlow.shapeMap[this.id];
    },
    isVisible() {
      return this.getRowVisibility(this.id.replace("activity_", ""));
    },
    radius() {
      return RADIUS;
    },
    points() {
      switch (this.shape.type) {
        case ShapeType.Or:
          return getOrPoints(this.shape.attributes.cx, this.shape.attributes.cy);
        case ShapeType.And:
          return getAndPoints(this.shape.attributes.cx, this.shape.attributes.cy);
        case ShapeType.Xor:
          return getXorPoints(this.shape.attributes.cx, this.shape.attributes.cy);
        default:
          return "";
      }
    },
    selectedShapeId() {
      return (
        this.$store.state.customFlow.selection.type === SelectionType.Circle &&
        this.$store.state.customFlow.selection.id
      );
    },
    cluePointsId() {
      return this.$store.state.customFlow.cluePointsId;
    },
  },
  methods: {
    mouseMove(event) {
      const startShapeId = this.$store.state.customFlow.newArrow.startShapeId;
      if (!startShapeId) return (this.disabled = false);

      const endShape = this.$store.state.customFlow.shapeMap[event.target.id];
      const connections = this.$store.state.customFlow.connections;
      this.disabled = endShape.incommingConnections.some((item) => connections[item].startShapeId === startShapeId);
    },
    setSelectedShape(e) {
      if (this.disabled) return; // Don't click if there is an arrow between two circles.

      const cx = this.shape.attributes.cx;
      const cy = this.shape.attributes.cy;

      const minPoint = [cx - RADIUS, cy - RADIUS];
      const maxPoint = [cx + RADIUS, cy + RADIUS];

      const data = {
        minPoint,
        maxPoint,
        id: this.id,
        type: SelectionType.Circle,
      };
      this.$store.dispatch("customFlow/setSelection", data);
      this.$store.dispatch("customFlow/setNewArrowData", {
        id: this.id,
        startShapeY: e.clientY,
      });
      this.$store.dispatch("setScope", HotkeyScopes.ProcessFlow); // Set scope inorder to move the shape with keyboard.
    },
    startDrag() {
      this.$store.dispatch("customFlow/resetSelection");
      this.dragging = true;
      this.pflowLeft = document.querySelector(".flow").getBoundingClientRect().left;
      document.addEventListener("mousemove", this.drag);
      document.addEventListener("mouseup", this.endDrag);
    },
    endDrag() {
      document.removeEventListener("mousemove", this.drag);
      document.removeEventListener("mouseup", this.endDrag);
      this.dragging = false;

      let lineNo = Math.floor(this.shape.attributes.cx / SPACE_BETWEEN_VLINES);
      let reminder = this.shape.attributes.cx % SPACE_BETWEEN_VLINES;
      let position =
        reminder > SPACE_BETWEEN_VLINES / 2 ? (lineNo + 1) * SPACE_BETWEEN_VLINES : lineNo * SPACE_BETWEEN_VLINES;

      this.$store.dispatch("customFlow/moveShape", {
        shapeId: this.id,
        cx: position,
      });
      this.$store.dispatch("customFlow/persist");
    },
    drag(e) {
      const cx = e.clientX - this.pflowLeft;
      if (cx <= SPACE_BETWEEN_VLINES / 2 || cx >= this.processFlowWidth - SPACE_BETWEEN_VLINES / 2) return; // 5 is like right padding.
      this.$store.dispatch("customFlow/moveShape", { shapeId: this.id, cx });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/variables";

.flow {
  &__color {
    stroke: @kk-color-primary-blue;
    &-dragging {
      stroke: hsl(205, 100%, 45%);
    }
  }
  &__cluepoints {
    stroke: @kk-color-primary-blue;
  }
  &__circle {
    pointer-events: auto; // This is because of custom cursor.
    transition: cx 0.3s ease;
    &:hover {
      stroke: @kk-color-gold;
    }
    &-dragging {
      transition: none;
    }
    &-disabled {
      cursor: not-allowed;
    }
  }
}
</style>
